<template>
  <div class="locations">
    <b-container >
      <b-row class="contact-row">
        <b-col lg="5" md="12" sm="12">
          <Locationcard
            :lenderName="locations.lenderName1"
            :lenderGrievanceRedressalOfficer="locations.lenderGrievanceRedressalOfficer1"
            :lenderPrivacyPolicy="locations.lenderPrivacyPolicy1"
            :lenderProductDetails="locations.lenderProductDetails1"
            :lenderImage="locations.lenderImage1"
            :callIcon="locations.callIcon"
          />
        </b-col>
      </b-row>
      <b-row class="contact-row"> 
        <b-col lg="5" md="12" sm="12">
          <Locationcard
            :lenderName="locations.lenderName2"
            :lenderGrievanceRedressalOfficer="locations.lenderGrievanceRedressalOfficer2"
            :lenderPrivacyPolicy="locations.lenderPrivacyPolicy2"
            :lenderProductDetails="locations.lenderProductDetails2"
            :lenderImage="locations.lenderImage2"
            :callIcon="locations.callIcon"
          />
        </b-col>
      </b-row>
      <b-row class="contact-row">
        <b-col lg="5" md="12" sm="12">
          <Locationcard
            :lenderName="locations.lenderName3"
            :lenderGrievanceRedressalOfficer="locations.lenderGrievanceRedressalOfficer3"
            :lenderPrivacyPolicy="locations.lenderPrivacyPolicy3"
            :lenderProductDetails="locations.lenderProductDetails3"
            :lenderImage="locations.lenderImage3"
            :callIcon="locations.callIcon"
          />
        </b-col>
      </b-row>
      <b-row class="contact-row">
        <b-col lg="5" md="12" sm="12">
          <Locationcard
            :lenderName="locations.lenderName4"
            :lenderGrievanceRedressalOfficer="locations.lenderGrievanceRedressalOfficer4"
            :lenderPrivacyPolicy="locations.lenderPrivacyPolicy4"
            :lenderProductDetails="locations.lenderProductDetails4"
            :lenderImage="locations.lenderImage4"
            :callIcon="locations.callIcon"
          />
        </b-col>
      </b-row>
      <b-row class="contact-row">
        <b-col lg="5" md="12" sm="12">
          <Locationcard
            :lenderName="locations.lenderName5"
            :lenderGrievanceRedressalOfficer="locations.lenderGrievanceRedressalOfficer5"
            :lenderPrivacyPolicy="locations.lenderPrivacyPolicy5"
            :lenderProductDetails="locations.lenderProductDetails5"
            :lenderImage="locations.lenderImage5"
            :callIcon="locations.callIcon"
          />
        </b-col>
      </b-row>
      <b-row class="contact-row">
        <b-col lg="5" md="12" sm="12">
          <Locationcard
            :lenderName="locations.lenderName6"
            :lenderGrievanceRedressalOfficer="locations.lenderGrievanceRedressalOfficer6"
            :lenderPrivacyPolicy="locations.lenderPrivacyPolicy6"
            :lenderProductDetails="locations.lenderProductDetails6"
            :lenderImage="locations.lenderImage6"
            :callIcon="locations.callIcon"
          />
        </b-col>
      </b-row>
      <b-row class="contact-row">
        <b-col lg="5" md="12" sm="12">
          <Locationcard
            :lenderName="locations.lenderName7"
            :lenderGrievanceRedressalOfficer="locations.lenderGrievanceRedressalOfficer7"
            :lenderPrivacyPolicy="locations.lenderPrivacyPolicy7"
            :lenderProductDetails="locations.lenderProductDetails7"
            :lenderImage="locations.lenderImage7"
            :callIcon="locations.callIcon"
          />
        </b-col>
      </b-row>
      <b-row class="contact-row">
        <b-col lg="5" md="12" sm="12">
          <Locationcard
            :lenderName="locations.lenderName8"
            :lenderGrievanceRedressalOfficer="locations.lenderGrievanceRedressalOfficer8"
            :lenderPrivacyPolicy="locations.lenderPrivacyPolicy8"
            :lenderProductDetails="locations.lenderProductDetails8"
            :lenderImage="locations.lenderImage8"
            :callIcon="locations.callIcon"
          />
        </b-col>
      </b-row>
      <b-row class="contact-row">
        <b-col lg="5" md="12" sm="12">
          <Locationcard
            :lenderName="locations.lenderName9"
            :lenderGrievanceRedressalOfficer="locations.lenderGrievanceRedressalOfficer9"
            :lenderPrivacyPolicy="locations.lenderPrivacyPolicy9"
            :lenderProductDetails="locations.lenderProductDetails9"
            :lenderImage="locations.lenderImage9"
            :callIcon="locations.callIcon"
          />
        </b-col>
      </b-row>
      <b-row class="contact-row">
        <b-col lg="5" md="12" sm="12">
          <Locationcard
            :lenderName="locations.lenderName10"
            :lenderGrievanceRedressalOfficer="locations.lenderGrievanceRedressalOfficer10"
            :lenderPrivacyPolicy="locations.lenderPrivacyPolicy10"
            :lenderProductDetails="locations.lenderProductDetails10"
            :lenderImage="locations.lenderImage10"
            :callIcon="locations.callIcon"
          />
        </b-col>
      </b-row>
      <b-row class="contact-row">
        <b-col lg="5" md="12" sm="12">
          <Locationcard
            :lenderName="locations.lenderName11"
            :lenderGrievanceRedressalOfficer="locations.lenderGrievanceRedressalOfficer11"
            :lenderPrivacyPolicy="locations.lenderPrivacyPolicy11"
            :lenderProductDetails="locations.lenderProductDetails11"
            :lenderImage="locations.lenderImage11"
            :callIcon="locations.callIcon"
          />
        </b-col>
      </b-row>
      <b-row class="contact-row">
        <b-col lg="5" md="12" sm="12">
          <Locationcard
            :lenderName="locations.lenderName12"
            :lenderGrievanceRedressalOfficer="locations.lenderGrievanceRedressalOfficer12"
            :lenderPrivacyPolicy="locations.lenderPrivacyPolicy12"
            :lenderProductDetails="locations.lenderProductDetails12"
            :lenderImage="locations.lenderImage12"
            :callIcon="locations.callIcon"
          />
        </b-col>
      </b-row>
      <b-row class="contact-row">
        <b-col lg="5" md="12" sm="12">
          <Locationcard
            :lenderName="locations.lenderName13"
            :lenderGrievanceRedressalOfficer="locations.lenderGrievanceRedressalOfficer13"
            :lenderPrivacyPolicy="locations.lenderPrivacyPolicy13"
            :lenderProductDetails="locations.lenderProductDetails13"
            :lenderImage="locations.lenderImage13"
            :callIcon="locations.callIcon"
          />
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import Locationcard from "../common/lendingPartners-card";
export default {
  name: "Locations",
  props: ["locations"],
  components: {
    Locationcard,
  },
};
</script>

<style scoped>
  .contact-row {
    justify-content: center;
  }

  @media (min-width: 768px) and (max-width: 1024px) and (orientation: portrait) {
    .contact-row {
      width: 75%;
      margin-left: auto;
      margin-right: auto;
    }
  }
</style>
